import { render, staticRenderFns } from "./block-notifications-container.vue?vue&type=template&id=90bd27d8&scoped=true&"
import script from "./block-notifications-container.vue?vue&type=script&lang=js&"
export * from "./block-notifications-container.vue?vue&type=script&lang=js&"
import style0 from "./block-notifications-container.vue?vue&type=style&index=0&id=90bd27d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bd27d8",
  null
  
)

export default component.exports